import { render, staticRenderFns } from "./OrderVpnVip.vue?vue&type=template&id=3c595596&scoped=true&"
import script from "./OrderVpnVip.vue?vue&type=script&lang=js&"
export * from "./OrderVpnVip.vue?vue&type=script&lang=js&"
import style0 from "./OrderVpnVip.vue?vue&type=style&index=0&id=3c595596&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c595596",
  null
  
)

export default component.exports